import {
  randomString,
  getFormData,
  devOrProd,
  devOrProdFeeds,
  nuqliumDataIndexSeven,
  nuqliumDataIndexSevenFeeds,
  getInternationalPriceNuqlium
} from '../shared/utils';

const randomStringAll = randomString();
const internationalPrice = getInternationalPriceNuqlium();

/* NQ DATA API */

/* Seven Black Friday Landing Page */
export const blackFridayLandingPage = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'pages',
    pagekey: 'black-friday-landing-page',
    'settings[mode]': 'web'
  })
};

/* Black Friday (All) Feed */
export const bfAllFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey:
      devOrProd === 'dev' ? 'nq-new-arrivals-all-feed' : 'nq-feed-bf-all',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Black Friday (Clothing) Feed */
export const bfClothingFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-feed-bf-clothing',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Black Friday (Footwear) Feed */
export const bfFootwearFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-feed-bf-footwear',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Black Friday (Accessories) Feed */
export const bfAccessoriesFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-feed-bf-accessories',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};
